class ProductReplacementSubscribe extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.wd-product-replacement-subscribe__tab')
    this.panels = this.querySelectorAll('.wd-product-replacement-subscribe__panel')

    if (!this.tabs.length || !this.panels.length) return

    this.addEventListener('click', this.onTabClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onTabClick)
  }

  onTabClick = event => {
    const tab = event.target.closest('.wd-product-replacement-subscribe__tab')
    if (!tab || !this.contains(tab)) return

    const targetId = tab.dataset.target
    if (!targetId) return

    this.tabs.forEach(item => {
      const isActive = item === tab
      item.classList.toggle('is-active', isActive)
      item.classList.toggle('h6-heavy', isActive)
      item.classList.toggle('h6-light', !isActive)
      item.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    this.panels.forEach(panel => {
      const isActive = panel.id === targetId
      panel.classList.toggle('is-active', isActive)
      panel.hidden = !isActive
    })

    this.refreshActiveSlider()
  }

  refreshActiveSlider() {
    const activePanel = this.querySelector('.wd-product-replacement-subscribe__panel.is-active')
    const slider = activePanel?.querySelector('splide-slider')
    if (!slider?.slider) return

    window.requestAnimationFrame(() => {
      slider.slider.refresh()
    })
  }
}
if (!customElements.get('product-replacement-subscribe')) {
  customElements.define('product-replacement-subscribe', ProductReplacementSubscribe)
}
